
define('text!meetings/welcome/welcome-title.html',[],function () { return '<div>\n    <div class="container" data-bind="visible: showWelcomeMsg()">\n        <div class="title" data-bind="text: welcomeMsg"></div>\n    </div>\n</div>';});

